import { axios } from 'shared';

import { ReferralInfo } from '../types';

export function getReferralInfo({ referralCode }: { referralCode: string }) {
  return axios.get<ReferralInfo>(`/v1/referral_info/${referralCode}`);
}
